import alertIcon from '../../../../../assets/alert-icon.png';

interface FleetNotFoundComponentProps {
  title: string;
  subtitle: string;
  messageError: string;
}
export const FleetNotFoundComponent = ({
  title,
  subtitle,
  messageError,
}: FleetNotFoundComponentProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        textAlign: 'center',
        minHeight: '300px',
      }}
    >
      <img
        src={alertIcon}
        alt='Erro'
        style={{ width: '48px', marginBottom: '20px' }}
      />
      <h2 style={{ color: '#B9381C', marginBottom: '10px' }}>{messageError}</h2>
      <p style={{ color: '#4F5962' }}>{title}</p>
      <p style={{ color: '#4F5962', fontSize: '14px' }}>{subtitle}</p>
    </div>
  );
};
